import { Sizes, LetterSpacings, LineHeights, TextTransforms } from '../typography/typography-tokens.js';

// GENERATED FILE, PLEASE DO NOT EDIT
var Bold40 = {
  size: Sizes.S40,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S40,
  textTransform: TextTransforms.Normal
};
var Bold32 = {
  size: Sizes.S32,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S32,
  textTransform: TextTransforms.Normal
};
var Bold24 = {
  size: Sizes.S24,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S24,
  textTransform: TextTransforms.Normal
};
var Bold22 = {
  size: Sizes.S22,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S22,
  textTransform: TextTransforms.Normal
};
var Bold18 = {
  size: Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.Normal
};
var Bold16 = {
  size: Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.Normal
};
var Bold14 = {
  size: Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.Normal
};
var Bold12 = {
  size: Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.Normal
};
var Medium24 = {
  size: Sizes.S24,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S24,
  textTransform: TextTransforms.Normal
};
var Medium18 = {
  size: Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.Normal
};
var Medium16 = {
  size: Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.Normal
};
var Medium14 = {
  size: Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.Normal
};
var Medium12 = {
  size: Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.Normal
};
var Caps18 = {
  size: Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.UpperCase
};
var Caps16 = {
  size: Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.UpperCase
};
var Caps14 = {
  size: Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.UpperCase
};
var Caps12 = {
  size: Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.UpperCase
};
var Caps10 = {
  size: Sizes.S10,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S10,
  textTransform: TextTransforms.UpperCase
};
var Regular18 = {
  size: Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.Normal
};
var Regular16 = {
  size: Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.Normal
};
var Regular14 = {
  size: Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.Normal
};
var Regular12 = {
  size: Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.Normal
};
var TextStyleLegacyTokensAll = {
  Bold40: Bold40,
  Bold32: Bold32,
  Bold24: Bold24,
  Bold22: Bold22,
  Bold18: Bold18,
  Bold16: Bold16,
  Bold14: Bold14,
  Bold12: Bold12,
  Medium24: Medium24,
  Medium18: Medium18,
  Medium16: Medium16,
  Medium14: Medium14,
  Medium12: Medium12,
  Caps18: Caps18,
  Caps16: Caps16,
  Caps14: Caps14,
  Caps12: Caps12,
  Caps10: Caps10,
  Regular18: Regular18,
  Regular16: Regular16,
  Regular14: Regular14,
  Regular12: Regular12
};

export { Bold12, Bold14, Bold16, Bold18, Bold22, Bold24, Bold32, Bold40, Caps10, Caps12, Caps14, Caps16, Caps18, Medium12, Medium14, Medium16, Medium18, Medium24, Regular12, Regular14, Regular16, Regular18, TextStyleLegacyTokensAll, TextStyleLegacyTokensAll as default };
